import { connect } from 'react-redux'

import onChangeFilter from './Handlers/onChangeFilter'

import Component from './Component'

const mapStateToProps = (state) => ({
  filters: state.screens.RetentionPayments.filters,
  clients: state.core.clients,
})

const actionCreators = {
  onChangeFilter
}

export default connect(mapStateToProps, actionCreators)(Component)